import { installationManifest } from './pwa-installation'

export interface ManifestWriter {
  update(value: object | string): string | undefined
  dispose(): void
}

// React and raw pages share the utility loaded by common.js.
export const createManifestWriter = (): ManifestWriter => {
  const writer = (window as any).manifest.createWriter()
  return {
    update(value) {
      if (typeof value === 'string') {
        try { return writer.update(installationManifest(JSON.parse(value))) } catch { return writer.update(value) }
      }
      return writer.update(installationManifest(value))
    },
    dispose: () => writer.dispose(),
  }
}
